const experience = [
  {
    role: "Backend Engineer (Remote)",
    company: "Techjamslab",
    date: "Aug 25 - Apr 26",
  },
  {
    role: "Fullstack Developer (Remote)",
    company: "Napmantronix Nig LTD",
    date: "Jan 23 - Dec 24",
  },
  {
    role: "Fullstack Developer (MERN)/Website Aministrator",
    company: "Blisshype Media Company",
    date: "Aug 19 - Sep 22",
  },
];

const firstExperince = {
  role: "Fullstack Developer (Intern)",
  company: "Softwave Technologies",
  date: "Jan 19 - Jul 19",
};

module.exports = {
  experience,
  firstExperince,
};
